import React, { Component } from 'react';
import '../App.css';
import {
  AppBar,
  Drawer,
  IconButton,
  ListItemIcon,
  List,
  ListItem,
  ListItemText,
  Tab,
  Tabs,
  Toolbar,
} from '@material-ui/core';
import MenuIcon from '@material-ui/icons/Menu';
import LogoutIcon from '@material-ui/icons/ExitToApp';
import logo from '../logo.png';
import { withStyles } from '@material-ui/styles';
import { NavLink, withRouter } from 'react-router-dom';
import MediaQuery from 'react-responsive';
import { retrieveToken } from '../utils/storage.js';
import {
  getCurrentAdminSection,
  getVisibleControlPanelTabs,
  isAdminPath,
} from '../scenes/controlpanel/controlPanelNavigation.js';
import { isLoggedUserAConsulente } from '../utils/storage.js';
import { fade } from '@material-ui/core/styles';

const styleToUse = (theme) => ({
  logo: {
    height: '50px',
    display: 'block',
  },
  button: {
    background: theme.palette.primary.main,
    borderRadius: '6px',
    border: 0,
    boxShadow: 'none',
    color: theme.palette.text.main,
    height: 48,
    fontWeight: 'bold',
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
    textTransform: 'none',
  },
  navLink: {
    textDecoration: 'none',
    color: theme.palette.primary.main,
  },
  logoLink: {
    alignItems: 'center',
    display: 'inline-flex',
    textDecoration: 'none',
  },
  /** Spacer so main content is not under the fixed AppBar (Toolbar minHeight is 72). */
  appBarOffset: {
    flexShrink: 0,
    minHeight: 72,
  },
  appBar: {
    width: '100%',
    left: 0,
  },
  toolbar: {
    minHeight: 72,
    paddingLeft: theme.spacing(4),
    paddingRight: theme.spacing(4),
  },
  toolbarNavigation: {
    flex: 1,
    marginLeft: theme.spacing(4),
    marginRight: theme.spacing(2),
    minWidth: 0,
  },
  mobileToolbar: {
    minHeight: 72,
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
  },
  adminTabs: {
    backgroundColor: 'transparent',
    minHeight: 72,
  },
  adminTab: {
    color: theme.palette.primary.main,
    minHeight: 72,
    minWidth: 88,
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    textTransform: 'none',
  },
  logoutButton: {
    color: theme.palette.primary.main,
  },
  drawerList: {
    paddingBottom: theme.spacing(2),
    width: 280,
  },
  drawerSectionTitle: {
    color: theme.palette.secondary.other,
    fontSize: '0.75rem',
    fontWeight: 700,
    letterSpacing: '0.08em',
    padding: theme.spacing(2, 2, 1),
    textTransform: 'uppercase',
  },
  selectedDrawerItem: {
    backgroundColor: fade(theme.palette.primary.main, 0.12),
  },
  list: {
    width: 250,
  },
});

class CustomHeader extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isDrawerOpen: false,
      logged: false,
    };
  }

  componentDidMount() {
    const token = retrieveToken();
    if (token !== null) {
      this.setState({
        logged: true,
      });
    } //else page does not display a content, only the header appears
  }

  toggleDrawer = (open) => {
    this.setState({
      isDrawerOpen: open,
    });
  };

  render() {
    const { classes, location, theme } = this.props;
    let isDrawerOpen = this.state.isDrawerOpen;
    const pathname = location ? location.pathname : '';
    const isConsulente = isLoggedUserAConsulente();
    const adminTabs = getVisibleControlPanelTabs({ isConsulente });
    const currentAdminSection = getCurrentAdminSection(pathname);
    const showAdminNavigation = isAdminPath(pathname);

    let logoLink = (
      <NavLink to="/" className={classes.logoLink} aria-label="Vai alla home">
        <img
          src={theme.logoLeft === '' ? logo : theme.logoLeft.url}
          className={classes.logo}
          alt="logo"
        />
      </NavLink>
    );

    let loginButton = this.state.logged ? (
      <NavLink
        to="/logout"
        style={{ textDecoration: 'none', display: 'inline-flex' }}
        aria-label="Logout"
        title="Logout"
      >
        <IconButton className={classes.logoutButton}>
          <LogoutIcon />
        </IconButton>
      </NavLink>
    ) : null;

    let drawerLoginButton = this.state.logged ? (
      <NavLink to="/logout" className={classes.navLink}>
        <ListItem button key="Logout">
          <ListItemIcon>
            <LogoutIcon style={{ color: theme.palette.primary.main }} />
          </ListItemIcon>
          <ListItemText primary="Logout" />
        </ListItem>
      </NavLink>
    ) : null;

    let drawerAdminTabs = showAdminNavigation
      ? adminTabs.map((tab) => (
          <NavLink key={tab.key} to={tab.to} className={classes.navLink}>
            <ListItem
              button
              className={
                currentAdminSection === tab.key
                  ? classes.selectedDrawerItem
                  : ''
              }
            >
              <ListItemText primary={tab.label} />
            </ListItem>
          </NavLink>
        ))
      : null;

    let sideList = (
      <div
        className={classes.drawerList}
        role="presentation"
        onClick={() => {
          this.toggleDrawer(false);
        }}
        onKeyDown={() => {
          this.toggleDrawer(false);
        }}
      >
        <List>
          {showAdminNavigation && (
            <ListItem>
              <ListItemText
                primary="Amministrazione"
                primaryTypographyProps={{
                  className: classes.drawerSectionTitle,
                }}
              />
            </ListItem>
          )}
          {drawerAdminTabs}
          {drawerLoginButton}
        </List>
      </div>
    );

    /**
     * <AppBar> is a component of material-ui library.
     * The top App Bar provides content and actions related to the current screen. It’s used for branding, screen titles, navigation, and actions.
     */
    return (
      <div>
        <MediaQuery minWidth={1000}>
          <React.Fragment>
            <AppBar
              className={classes.appBar}
              style={{
                backgroundColor: theme.palette.background.paper,
              }}
              position="fixed"
              elevation={0}
            >
              <Toolbar className={classes.toolbar}>
                {logoLink}
                {showAdminNavigation ? (
                  <Tabs
                    value={currentAdminSection || false}
                    indicatorColor="primary"
                    textColor="primary"
                    variant="scrollable"
                    scrollButtons="auto"
                    className={`${classes.toolbarNavigation} ${classes.adminTabs}`}
                    TabIndicatorProps={{
                      style: {
                        height: 3,
                      },
                    }}
                  >
                    {adminTabs.map((tab) => (
                      <Tab
                        key={tab.key}
                        className={classes.adminTab}
                        component={NavLink}
                        label={tab.label}
                        to={tab.to}
                        value={tab.key}
                      />
                    ))}
                  </Tabs>
                ) : (
                  <div style={{ flexGrow: 1 }}></div>
                )}
                {loginButton}
              </Toolbar>
            </AppBar>
            <div className={classes.appBarOffset} aria-hidden />
          </React.Fragment>
        </MediaQuery>

        <MediaQuery maxWidth={1000}>
          <React.Fragment>
            <AppBar
              className={classes.appBar}
              position="fixed"
              style={{
                backgroundColor: theme.palette.background.paper,
              }}
              elevation={0}
            >
              <Toolbar className={classes.mobileToolbar}>
                {logoLink}
                <div style={{ flexGrow: 1 }}></div>
                <IconButton
                  aria-haspopup="true"
                  aria-label="Apri il menu di navigazione"
                  onClick={() => {
                    this.toggleDrawer(true);
                  }}
                >
                  <MenuIcon style={{ color: theme.palette.primary.main }} />
                </IconButton>
                <Drawer
                  anchor="right"
                  open={isDrawerOpen}
                  onClose={() => {
                    this.toggleDrawer(false);
                  }}
                >
                  {sideList}
                </Drawer>
              </Toolbar>
            </AppBar>
            <div className={classes.appBarOffset} aria-hidden />
          </React.Fragment>
        </MediaQuery>
      </div>
    );
  }
}
export default withRouter(
  withStyles(styleToUse, { withTheme: true })(CustomHeader),
);
